import produce from 'immer';
import { useEffect, useState } from 'react';
import useClients from '../../../hooks/useClients';
import userFormSchema from './userFormSchema.json';
import useClientProperties from '../../../hooks/useClientProperties';

const useUserForm = (clientId: string, forClient) => {
  const [userForm, setUserForm] = useState(userFormSchema);
  const { clients, isLoading } = useClients();
  const { properties, isLoading: isPropertiesLoading } =
    useClientProperties(clientId);
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (clients) {
      setUserForm((form) => {
        return produce(form, (draftForm) => {
          draftForm.properties.ClientId.readOnly = forClient ? true : false;
          draftForm.properties.ClientId.oneOf = Object.values(clients).map(
            (elem: any) => {
              return {
                const: elem.id,
                title: elem.ClientName,
              };
            }
          );

          if (clientId) {
            if (
              !isPropertiesLoading &&
              properties &&
              clients[clientId].ManagedProperties
            ) {
              const enums = clients[clientId].ManagedProperties.map((elem) =>
                elem.toString()
              );

              const managedProperties = properties
                .filter((elem) => enums.includes(elem.value.toString()))
                .reduce((acc, curr) => {
                  acc[curr.value] = curr.text;
                  return acc;
                }, {});

              const anyOf = enums.map((elem) => ({
                type: 'string',
                enum: [elem],
                title: `${managedProperties[elem]} - ${elem}`,
              }));
              draftForm.properties.ManagedProperties.items.anyOf = anyOf;
            }
          }
          setUpdated(true);
        });
      });
    }
  }, [clients, clientId, forClient, properties, isPropertiesLoading]);

  useEffect(() => {}, []);

  return { userForm, isLoading, updated };
};
export default useUserForm;
